/* eslint-disable consistent-return */

import { Mongo } from 'meteor/mongo';
import SimpleSchema from 'simpl-schema';
import { pick } from 'lodash';

import AnnotationPropertiesSchema from './AnnotationPropertiesSchema';
import { FeaturePoint } from '../SchemaUtilities/GeoJSONSchema';

export const ANNOTATION_AI_ENTITIES_GROUPS = {
  URBAN_FURNITURE: 'urbanFurniture',
  PEOPLE_UTILITIES: 'people',
  VEHICLES: 'vehicles',
  ANIMALS: 'animals',
  properties: {
    URBAN_FURNITURE: {
      name: 'URBAN_FURNITURE',
      value: 'urbanFurniture',
      humanValue: 'Urban furniture'
    },
    PEOPLE_UTILITIES: {
      name: 'PEOPLE_UTILITIES',
      value: 'people',
      humanValue: 'People'
    },
    VEHICLES: {
      name: 'VEHICLES',
      value: 'vehicles',
      humanValue: 'Vehicles'
    },
    ANIMALS: {
      name: 'ANIMALS',
      value: 'animals',
      humanValue: 'Animals'
    }
  }
};

export const ANNOTATION_EXPORT_FORMATS = {
  PDF: 'PDF',
  KML: 'KML',
  GEOJSON: 'GeoJSON'
};

export const ANNOTATION_AI_ENTITIES = {
  SEMAFOROS: 'semaforos',
  STOPS: 'stops',
  BANCOS: 'bancos',
  PERSONAS: 'personas',
  MOCHILAS: 'mochilas',
  BOLSOS: 'bolsos',
  MALETAS: 'maletas',
  PARAGUAS: 'paraguas',
  BICICLETAS: 'bicicletas',
  COCHES: 'coches',
  MOTOCICLETAS: 'motocicletas',
  BUSES: 'buses',
  TRENES: 'trenes',
  CAMIONES: 'camiones',
  BARCOS: 'barcos',
  AVIONES: 'aviones',
  PAJAROS: 'pajaros',
  GATOS: 'gatos',
  PERROS: 'perros',
  CABALLOS: 'caballos',
  OVEJAS: 'ovejas',
  VACAS: 'vacas',
  ELEFANTES: 'elefantes',
  OSOS: 'osos',
  CEBRAS: 'cebras',
  JIRAFAS: 'jirafas',
  properties: {
    SEMAFOROS: {
      name: 'SEMAFOROS',
      value: 'semaforos',
      humanValue: 'Traffic lights'
    },
    STOPS: {
      name: 'STOPS',
      value: 'stops',
      humanValue: 'Stop signals'
    },
    BANCOS: {
      name: 'BANCOS',
      value: 'bancos',
      humanValue: 'Benches'
    },
    PERSONAS: {
      name: 'PERSONAS',
      value: 'personas',
      humanValue: 'People'
    },
    MOCHILAS: {
      name: 'MOCHILAS',
      value: 'mochilas',
      humanValue: 'Backpacks'
    },
    BOLSOS: {
      name: 'BOLSOS',
      value: 'bolsos',
      humanValue: 'Handbags'
    },
    MALETAS: {
      name: 'MALETAS',
      value: 'maletas',
      humanValue: 'Suitcases'
    },
    PARAGUAS: {
      name: 'PARAGUAS',
      value: 'paraguas',
      humanValue: 'Umbrellas'
    },
    BICICLETAS: {
      name: 'BICICLETAS',
      value: 'bicicletas',
      humanValue: 'Bicycles'
    },
    COCHES: {
      name: 'COCHES',
      value: 'coches',
      humanValue: 'Cars'
    },
    MOTOCICLETAS: {
      name: 'MOTOCICLETAS',
      value: 'motocicletas',
      humanValue: 'Motorcycles'
    },
    BUSES: {
      name: 'BUSES',
      value: 'buses',
      humanValue: 'Buses'
    },
    TRENES: {
      name: 'TRENES',
      value: 'trenes',
      humanValue: 'Trains'
    },
    CAMIONES: {
      name: 'CAMIONES',
      value: 'camiones',
      humanValue: 'Tracks'
    },
    BARCOS: {
      name: 'BARCOS',
      value: 'barcos',
      humanValue: 'Boats'
    },
    AVIONES: {
      name: 'AVIONES',
      value: 'aviones',
      humanValue: 'Planes'
    },
    PAJAROS: {
      name: 'PAJAROS',
      value: 'pajaros',
      humanValue: 'Birds'
    },
    GATOS: {
      name: 'GATOS',
      value: 'gatos',
      humanValue: 'Cats'
    },
    PERROS: {
      name: 'PERROS',
      value: 'perros',
      humanValue: 'Dogs'
    },
    CABALLOS: {
      name: 'CABALLOS',
      value: 'caballos',
      humanValue: 'Horses'
    },
    OVEJAS: {
      name: 'OVEJAS',
      value: 'ovejas',
      humanValue: 'Sheeps'
    },
    VACAS: {
      name: 'VACAS',
      value: 'vacas',
      humanValue: 'Cows'
    },
    ELEFANTES: {
      name: 'ELEFANTES',
      value: 'elefantes',
      humanValue: 'Elefants'
    },
    OSOS: {
      name: 'OSOS',
      value: 'osos',
      humanValue: 'Bears'
    },
    CEBRAS: {
      name: 'CEBRAS',
      value: 'cebras',
      humanValue: 'Zebras'
    },
    JIRAFAS: {
      name: 'JIRAFAS',
      value: 'jirafas',
      humanValue: 'Giraffes'
    }
  }
};

export const URBAN_FURNITURE_AI_ENTITIES = pick(ANNOTATION_AI_ENTITIES, [
  'SEMAFOROS',
  'STOPS',
  'BANCOS'
]);

export const PEOPLE_UTILITIES_AI_ENTITIES = pick(ANNOTATION_AI_ENTITIES, [
  'PERSONAS',
  'MOCHILAS',
  'BOLSOS',
  'MALETAS',
  'AVIONES'
]);

export const VEHICLES_AI_ENTITIES = pick(ANNOTATION_AI_ENTITIES, [
  'BICICLETAS',
  'COCHES',
  'MOTOCICLETAS',
  'BUSES',
  'TRENES',
  'CAMIONES',
  'BARCOS',
  'AVIONES'
]);

export const ANIMALS_AI_ENTITIES = pick(ANNOTATION_AI_ENTITIES, [
  'PAJAROS',
  'GATOS',
  'PERROS',
  'CABALLOS',
  'OVEJAS',
  'VACAS',
  'ELEFANTES',
  'OSOS',
  'CEBRAS',
  'JIRAFAS'
]);

/**
 * Get the entities allowed for each entity group.
 *
 * @param {string} entityGroup - The entity group..
 * @returns {object} The entities allowed for each group.
 */
export const getEntitiesForGroup = entityGroup => {
  switch (entityGroup) {
    case ANNOTATION_AI_ENTITIES_GROUPS.URBAN_FURNITURE:
      return URBAN_FURNITURE_AI_ENTITIES;
    case ANNOTATION_AI_ENTITIES_GROUPS.PEOPLE_UTILITIES:
      return PEOPLE_UTILITIES_AI_ENTITIES;
    case ANNOTATION_AI_ENTITIES_GROUPS.VEHICLES:
      return VEHICLES_AI_ENTITIES;
    case ANNOTATION_AI_ENTITIES_GROUPS.ANIMALS:
      return ANIMALS_AI_ENTITIES;
    default:
      return {};
  }
};

const Annotations = new Mongo.Collection('Annotations');

Annotations.allow({
  insert: () => false,
  update: () => false,
  remove: () => false
});

Annotations.deny({
  insert: () => true,
  update: () => true,
  remove: () => true
});

const pointWithoutPropertiesSchema = FeaturePoint.omit('properties');
Annotations.schema = new SimpleSchema({
  annotationId: {
    type: String,
    label: 'The id of the annotation.',
    optional: true
  },
  owner: {
    type: String,
    label: 'The ID of the user this annotation belongs to'
  },
  createdAt: {
    type: String,
    label: 'The date this annotation was created in the database',
    autoValue() {
      if (this.isInsert) return new Date().toISOString();
    }
  },
  updatedAt: {
    type: String,
    label: 'The date this annotation was last updated',
    autoValue() {
      if (this.isInsert || this.isUpdate) return new Date().toISOString();
    }
  },
  geoJSON: {
    type: pointWithoutPropertiesSchema,
    label: 'The geospacial and video-related information and the structure of the annotation'
  },
  'geoJSON.properties': {
    type: AnnotationPropertiesSchema,
    label: 'The information and structure of the annotation'
  },
  origin: {
    type: String,
    label: 'The way of creating the annotation',
    allowedValues: ['manual', 'automatic', 'importMaps', 'importJsonMaps']
  },
  isTracking: {
    type: Boolean,
    label: 'Flag if the annotation is tracked or not.',
    optional: true
  },
  timeGPS: {
    type: Number,
    label: 'Tiempo gps.',
    autoValue() {
      if (this.isInsert) {
        return 1000 * (new Date().getTime() - new Date('1980-01-06T00:00:00Z').getTime());
      }
    },
    optional: true
  }
});

Annotations.attachSchema(Annotations.schema);

export default Annotations;
